<template>
  <div class="cj-carousel">
    <button
      class="scroll scroll-left"
      @click="$refs.scrollview.scrollPrev()"
    />

    <CJScrollView
      ref="scrollview"
      supress="y"
      snap="x"
      :margin="20"
      :spacing="20"
    >
      <div class="container carousel-items" v-if="items && items.length">
        <template v-for="item in items">
          <slot name="item" v-bind="item" />
        </template>
      </div>

      <div class="container carousel-items" v-else>
        <slot />
      </div>
    </CJScrollView>

    <button
      class="scroll scroll-right"
      @click="$refs.scrollview.scrollNext()"
    />
  </div>
</template>

<script>
import CJScrollView from '@/components/CJScrollView'

export default {
  name: 'CJCarousel',

  components: { CJScrollView },

  props: {
    items: {
      type: Array,
      default: () => [ ],
    },
  },

  data () {
    return {
      scrollX: 0,
      xMin: 0,
      xMax: 0,
      snapPoints: [ ],
    }
  },

  mounted () {
    const { scrollWidth, clientWidth } = this.$el.childNodes[1]
    const width = clientWidth + 20

    this.xMin = 20
    this.xMax = scrollWidth - width
  },

  methods: {
    scrollLeft () {
      this.$refs.scrollview.scrollPrev()
    },

    scrollRight () {
      this.$refs.scrollview.scrollNext()
    },

    /** @param {HTMLElement} el */
    scrollIntoView (el) {
      this.$refs.scrollview.scrollIntoView(el)
    },
  },
}
</script>

<style lang="stylus" scoped>
  .cj-carousel
    display: flex
    height: 108px

    button
      flex: 1 0 auto
      cursor: pointer

    .carousel-items
      display: flex
      flex: 1 0 auto
      flex-wrap: nowrap
      align-items: center
      margin: 0
      padding: 0
      height: 100%
      list-style-type: none

      &::before
      &::after
        display: block
        flex: 1 0 auto
        width: 10px
        height: 100%
        content: ''
</style>
